import pink from '@material-ui/core/colors/pink';
import lightGreen from '@material-ui/core/colors/lightGreen';
import dark from '@material-ui/core/colors/blueGrey';

const styles = theme => ({
  divider: {
    margin: `${theme.spacing.unit * 3}px 0`
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    }
  },
  borderPrimary: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  disabledPrimary: {
    color: 'rgba(255, 255, 255, 0.5) !important',
  },
  card: {
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
  },
  cardCartoon: {
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
    '& :first-child': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  cardColumn: {
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
    border: 'none !important',
    display: 'flex',
    flexDirection: 'row',
    gap: '0px',
    height: '100%',
    transition: 'box-shadow 0.3s ease',
    cursor: 'pointer',
    '& :first-child': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15) !important',
      '& $titleWrap2, & $title': {
        color: '#055EC2 !important',
      },
      '& $kicker': {
        color: '#055EC2 !important',
      },
      '& button$colorPrimary': {
        backgroundColor: '#055EC2 !important',
        color: '#ffffff !important',
      }
    }
  },
  cardSearching: {
    display: 'flex',
    gap: '5px',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    boxShadow: 'none !important',
    borderRadius: '0 !important',
  },
  cardColumnCarousel: {
    flexDirection: 'column !important',
    border: '1px solid #e0e0e0 !important',
    borderRadius: '0px !important',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF !important',
    maxWidth: '340px',
  },
  horizontal: {
    display: "flex",
    flexDirection: "row-reverse",
    height: "100%",
    gap: "10px",
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
    '& $mediaCardHorizontal': {
      [theme.breakpoints.down('xs')]: {
        minHeight: 200,
        width: '100%'
      },
    }
  },
  contenidoMedia: {
    padding: '0 !important',
  },
  pushBtn: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  contenidoCartoon: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '.7rem 0 !important',
  },
  liked: {
    color: pink[500]
  },
  shared: {
    color: lightGreen[500]
  },
  num: {
    fontSize: 14,
    marginLeft: 5
  },
  rightIcon: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center'
  },
  date: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontFamily: "Rubik, Oswald",
  },
  datePicker: {
    display: 'inline-block',
    marginRight: 5,
    fontSize: '.8rem'
  },
  dateRelevante: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '.8rem',
    fontFamily: "Rubik, Oswald",
  },
  button: {
    lineHeight: '1em',
    fontSize: '12px',
    minHeight: 'initial',
    marginTop: 5,
    padding: '7px 14px !important',
    fontWeight:400,
    fontFamily: "Rubik, Oswald",
    height: '26px !important'
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  w50responsive:{
    flex: 1
  },
  mediaHorizontal: {
    width: '50%',
    height: '100%',
    position: 'relative',
    backgroundColor: '#f2f2f2',
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      width: '100%'
    }
  },
  mediaCardHorizontal: {
    width: '200px',
    height: 'calc(100% - 10px)',
    position: 'relative',
    backgroundColor: '#f2f2f2',
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      width: '100%',
      objectFit: 'cover',
      height: '100%',
      [theme.breakpoints.down('xs')]: {
        objectFit: 'fill',
      },
    }
  },
  dividerLine: {
    paddingBottom: 8, 
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.primary.main,
  },
  dividerLineResponsive: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 8, 
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.primary.main,
    }
  },
  dividerLineHidden: {
    paddingBottomg: 0,
    border: 'none !important'
  },
  autor:{
    fontWeight: 300,
    fontFamily: "Rubik, Oswald",
    fontSize: '1.1rem',
    marginBottom: 10,
    color: theme.palette.primary.main,
  },
  mediaColumn: {
    position: 'relative',
    backgroundColor: '#f2f2f2',
    margin: '0',
    minWidth: '175px',
    width: '175px',
    aspectRatio: '1 / 1',
    overflow: 'hidden',
    flexShrink: 0,
    '& div':{
      height: '100%',
      width: '100%',
    },
    '& img':{
      height: '100%',
      width: '100%',
      objectFit: 'cover'
    }
  },
  mediaColumnCarousel: {
    width: '100% !important',
    minWidth: '100% !important',
    height: '175px !important',
    aspectRatio: 'unset !important',
  },
  wrapperAutor: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
  },
  mediaColumnSmall: {
    width: 40,
    minWidth: 40,
    height: 40,
    aspectRatio: '1 / 1',
  },
  contenidoColumn: {
    padding: '8px !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    minHeight: 0,
  },
  contenidoColumnSearching: {
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    minHeight: 0,
  },
  columnHeader: {
    display: 'flex',
    flexDirection: 'column',
  },
  columnFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    marginTop: 'auto',
    paddingTop: '12px',
    gap: '8px',
  },
  mediaEditoriales: {
    position: 'relative',
    backgroundColor: '#f2f2f2',
    margin: '0 24px',
    height: 175,
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      width: '100%'
    }
  },
  mediaEditorialesTexto: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f00',
    margin: '0 24px',
    height: 140,
    overflow: 'hidden',
    '& p':{
      color: '#fff',
      fontSize: 18,
      padding: '0 10px'
    },
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      width: '100%'
    }
  },
  mediaCartoon: {
    position: 'relative',
    backgroundColor: '#ffffff',
    margin: '0',
    height: 300,
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      width: '100%'
    }
  },
  mediaRelevante: {
    position: 'relative',
    height: 160,
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      width: '100%'
    }
  },
  cardRelevante:{
    backgroundColor: "transparent !important",
    borderRadius: "5px 5px 26px 5px !important",
    boxShadow: 'none !important',
    border: '3px solid white',
    textAlign: 'center !important',
    color: '#fff !important',
    height: '100%',
    '& p':{
      color: '#fff !important'
    },
    '& button':{
      backgroundColor: '#fff !important',
      lineHeight: '1em',
      fontSize: '.7rem',
      minHeight: 'initial',
      marginTop: 5,
      padding: '6px 14px',
      fontWeight:400,
      justifySelf: 'flex-end !important',
      alignSelf: 'center'
    }
  },
  contentRelevante: {
    marginBottom: 0,
    paddingBottom: '15px !important',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardPlayer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 150,
    height: 150,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  cardSocmed: {
    minWidth: 275,
  },
  cardProduct: {
    position: 'relative'
  },
  mediaProduct: {
    height: 0,
    paddingTop: '60.25%', // 16:9
  },
  rightAction: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    '& small': {
      fontSize: 12
    }
  },
  floatingButtonWrap: {
    position: 'relative',
    paddingTop: 50
  },
  buttonAdd: {
    position: 'absolute',
    right: 20,
    top: -20,
  },
  buttonAddList: {
    display: 'none',
    marginLeft: 10
  },
  title: {
    fontSize: 14,
    fontFamily: "Rubik, Oswald",
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  },
  titleRadio: {
    fontSize: 20,
    fontFamily: "Rubik, Oswald",
    color: theme.palette.primary.main,
  },
  titleRelevant: {
    fontSize: 20,
    fontFamily: "Rubik, Oswald",
    color: theme.palette.primary.main,
    textAlign: 'left !important'
  },
  titleWrap2: {
    color: theme.palette.primary.main,
    fontSize: 14,
    whiteSpace: "initial !important",
    lineHeight: "1.2",
    fontWeight: 'bold',
    fontFamily: "Rubik, Oswald",
    minHeight: "36px !important",
  },
  ratting: {
    margin: '10px 0',
    '& button': {
      width: 24,
      height: 24
    }
  },
  status: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: 10,
    '& > *': {
      margin: 5
    }
  },
  desc: {
    height: 45,
    overflow: 'hidden'
  },
  chipDiscount: {
    background: theme.palette.primary.light,
    color: theme.palette.primary.dark,
  },
  chipSold: {
    background: dark[500],
    color: theme.palette.getContrastText(dark[500]),
  },
  contentProfle: {
    flex: '1 0 auto',
    textAlign: 'center'
  },
  mediaProfile: {
    height: 0,
    paddingTop: '36.25%', // 16:9
  },
  actions: {
    display: 'flex',
    backgroundColor: 'transparent !important',
    padding: '0 24px 0 !important',
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px 0 !important',
    },
  },
  avatarBig: {
    width: 80,
    height: 80,
    margin: '-56px auto 10px',
    background: theme.palette.secondary.dark
  },
  name: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonProfile: {
    margin: 20
  },
  bottomLink: {
    width: '100%',
  },
  price: {
    paddingBottom: 20
  },
  contentProfile: {
    textAlign: 'center'
  },
  verified: {
    fontSize: 16,
    color: theme.palette.primary.main
  },
  cardList: {
    display: 'flex',
    justifyContent: 'space-between',
    '& $buttonAddList': {
      display: 'inline-block'
    },
    '& $floatingButtonWrap': {
      flex: 1,
    },
    '& $buttonAdd': {
      display: 'none'
    },
    '& $status': {
      right: 'auto',
      left: 0,
    },
    '& $mediaProduct': {
      width: 300,
      paddingTop: '21.25%'
    },
    '& $price': {
      flexDirection: 'column',
      justifyContent: 'center',
      '& button': {
        marginTop: 20
      }
    }
  },
  televisaContent: {
    textAlign: 'left',
  },
  textLeft: {
    textAlign: 'left',
  },
  color1: {
    backgroundColor: theme.palette.primary.main
  },
  color2: {
    backgroundColor: theme.palette.secondary.main
  },
  color3: {
    backgroundColor: '#006687'
  },
  btnContrast:{
    color: "#cacaca"
  },
  btnActive: {
    color: theme.palette.primary.contrastText
  },
  rightIconB: {
    fontSize: 18,
    marginLeft: 5
  },
  more: {
    marginTop: 5,
    '& a': {
      color: theme.palette.primary.main,
      display: 'flex',
      textDecoration: 'none',
      cursor: 'pointer'
    }
  },
  paddingBottom: {
    paddingBottom: 15
  },
  moreCarton: {
    marginTop: 5,
    '& a': {
      color: '#141414',
      display: 'flex',
      textDecoration: 'none',
      cursor: 'pointer',
    }
  },
  cardMediaRadio: {
    backgroundColor: 'transparent !important',
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    display: 'flex',
    flexFlow: 'row nowrap',
    height: '100%',
    minWidth: 275,
    padding: 0,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  cardEvent: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    height: '100%',
    gap: '5px',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing.unit * 2,
  },
  mediaRadio:{
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 70px',
    '@media (max-width: 360px)': {
      padding: '0 40px',
    },
    cursor:"pointer"
  },
  mediaRadio2:{
    backgroundColor: theme.palette.primary.main,
    '& div':{
      height: '100%',
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
      },
    },
    '& img':{
      height: '100%',
      width: '300px',
      objectFit: 'none',
      [theme.breakpoints.down('xs')]: {
        width: 'auto',
        height: '200px',
      },
    },
    cursor:"pointer"
  },
  mediaIcon:{
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 20px',
    '@media (max-width: 360px)': {
      padding: '0 10px',
    },
  },
  headerEvent:{
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  iconBig:{
    width: 98,
    height: 98,
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.2)',
    flexDirection: 'column',
    '@media (max-width: 360px)': {
      width: 50,
      height: 50,
    },
    '& p:first-child':{
      margin: 0,
      fontSize: '1.9rem',
      lineHeight: '1.9rem'
    },
    '& p':{
      margin: 0,
      fontSize: '1.6rem',
      lineHeight: '1.9rem'
    },
    '& svg':{
      fontSize: 32,
      '@media (max-width: 360px)': {
        fontSize: 25,
      },
    }
  },
  contenidoMediaIcon:{
    width: '100%',
    padding: '10px',
    backgroundColor: '#e6e6e6'
  },
  busqueda: {
    border: 'none !important',
    minWidth: 50,
    maxWidth: '100%',
    // marginBottom: 15,
    '& $cardContentVertical': {
      padding: '0px !important',
    },
  },
  programRadio: {
    color: theme.palette.primary.main,
    opacity: 0.7,
    fontFamily: "Rubik, Oswald",
  },
  descriptionRelevant: {
    fontFamily: "Rubik !important",
    textAlign: "left !important"
  },
  description: {
    fontFamily: "Rubik !important",
    wordBreak: "break-word",
  },
  descriptionWrap8: {
    fontFamily: "Rubik !important",
    whiteSpace: "initial !important",
    fontSize: "12px",
    lineHeight: "1.2",
    '& p':{
      margin: 0
    }
  },
  textDescriptionWrap8: {
    lineHeight: 'normal'
  },
  mb1: {
    margin: '0 0 0.5rem 0',
  },
  mt1: {
    margin: '1rem 0 0 0'
  },
  eventDescription: {
    color: theme.palette.secondary.main,
    fontFamily: "Rubik, Oswald",
  },
  wrapperBaseline: {
    display: 'flex',
    alignItems: 'baseline',
  },
  kicker : {
    color: theme.palette.secondary.main,
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: "Rubik, Oswald",
    display: 'inline-block',
    marginRight: '5px',
    marginBottom: '0.4rem',

  },
  transparentText: {
    color: 'transparent',
    userSelect: 'none',
  },
  stylesTextEvent: {
    color: theme.palette.primary.main,
    fontSize: '14px !important',
    fontWeight: '500',
    textTransform: 'uppercase',
    textWrap: 'nowrap',
  },
  h100: {
    height: '100%'
  },
  cardVertical: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: '1px solid #e0e0e0',
    borderRadius: '0px !important',
    overflow: 'hidden',
    transition: 'box-shadow 0.3s ease',
    backgroundColor: `#ffffff !important`,
    '&:hover': {
      boxShadow: '0 4px 10px rgba(5, 94, 194, 0.6) !important',
      '& $kickerVertical': {
        color: '#055EC2 !important',
      },
      '& $titleVertical': {
        color: '#055EC2 !important',
      },
      '& button$colorPrimary': {
        backgroundColor: '#055EC2 !important',
        color: '#ffffff !important',
      },
      '& $mediaVertical': {
        transform: 'scale(1.1)',
      }
    },
    '&$busqueda': {
      '&:hover': {
        boxShadow: 'none !important',
      }
    }
  },
  mediaCardVertical: {
    width: '100%',
    height: '180px',
    position: 'relative',
    backgroundColor: '#f2f2f2',
    overflow: 'hidden',
    '& div': {
      height: '100%',
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    }
  },
  mediaVertical: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
  },
  cardContentVertical: {
    padding: '16px !important',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
  },
  kickerVertical: {
    fontSize: '10px',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontFamily: "Rubik, Oswald",
    margin: 0,
    transition: 'color 0.3s ease',
  },
  titleVertical: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '1.3',
    fontFamily: "Rubik, Oswald",
    margin: 0,
    transition: 'color 0.3s ease',
    color: theme.palette.primary.main,
  },
  descriptionVertical: {
    fontSize: '12px',
    lineHeight: '1.5',
    fontFamily: "Rubik",
    color: '#666',
    flex: 1,
    '& p': {
      margin: 0,
      '& span': {
        color: '#000000 !important'
      }
    },
    '& span': {
      display: 'block',
      // display: '-webkit-box',
      // WebkitLineClamp: 4,
      // WebkitBoxOrient: 'vertical',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
    }
  },
  descriptionVerticalNoImage: {
    fontSize: '12px',
    lineHeight: '1.5',
    fontFamily: "Rubik",
    color: '#666',
    flex: 1,
    '& p': {
      margin: 0,
      '& span': {
        color: '#000000 !important'
      }
    }
  },
  footerCard: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
  },
  buttonVertical: {
    transition: 'background-color 0.3s ease, color 0.3s ease',
  },
  noMB: {
    marginBottom: 0
  }
});

export default styles;
